import { useCallback } from 'react';
import { benefits } from '../benefits';
import { useIsTierUnlockedForSpace } from './useIsTierUnlockedForSpace';
import useRequiredTierCallback from './useRequiredTierCallback';
export const useRequiredBenefitCallbackWithSpaces = (cb, benefitId, disabled = false, hideModal, forceMicroModalVersion) => {
    const isUnlockedForSpace = useIsTierUnlockedForSpace(benefits[benefitId].minTier);
    const validIf = useCallback(() => isUnlockedForSpace || disabled, [disabled, isUnlockedForSpace]);
    const requiredCallback = useRequiredTierCallback(cb, benefits[benefitId].minTier, validIf, benefitId, hideModal, undefined, undefined, forceMicroModalVersion);
    return requiredCallback;
};
const useRequiredBenefitCallback = (cb, benefitId, hideModal, skipTrialScreen, upsellTrial, forceMicroModalVersion) => useRequiredTierCallback(cb, benefits[benefitId].minTier, undefined, benefitId, hideModal, skipTrialScreen, upsellTrial, forceMicroModalVersion);
export default useRequiredBenefitCallback;
